import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, pipe, throwError} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import decode from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../settings';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';



const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {
  private message: string;

  constructor(private _router: Router,private http: HttpClient ) {


   }


   removeNotification(obj:any):Observable<any>{


    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'notification.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }

   removeArticle(obj:any):Observable<any>{


    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'article.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }



   removeNewsletter(obj:any):Observable<any>{


    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'newsletter.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }

   removeTemplate(obj:any):Observable<any>{


    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'template.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }

   
   removeTemplateGroup(obj:any):Observable<any>{


    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'group.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }

  removeUserGroup(obj:any):Observable<any>{


    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'department.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }
     
   removeType(obj:any):Observable<any>{



    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'type.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }


   
   removeCategory(obj:any):Observable<any>{



    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'category.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }



   articleStatus(obj:any):Observable<any>{



    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'workflow.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }


   articleUpdate(obj:any):Observable<any>{



    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'article.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }



   articleData(obj:any):Observable<any>{



    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'article.php';

       return this.http.post<any>(api_url, obj,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }

  articleDataFiltered(obj:any):Observable<any>{



    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };

        let api_url =AppSettings.API_ENDPOINT+'article.php';

       return this.http.post<any>(api_url, obj.desc,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }

  getCategoryList(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'category.php';

     return this.http.post<any>(api_url, obj,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }

  getCategoryType(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'type.php';

     return this.http.post<any>(api_url, obj,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }

  getTemplateGroup(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'group.php';

     return this.http.post<any>(api_url, obj,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }

  getUserGroup(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'department.php';

     return this.http.post<any>(api_url, obj,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }

  countryGroup(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'countrygroup.php';

     return this.http.post<any>(api_url, obj,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }

  getCountryGroup(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'countrygroup.php';

     return this.http.post<any>(api_url, obj,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }

  
  getTemplateList(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'template.php';

     return this.http.post<any>(api_url, obj,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }
  
  createArticle(obj:any):Observable<any>{



    try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,

          })
        };
        
        let api_url =AppSettings.API_ENDPOINT+'article.php';

       return this.http.post<any>(api_url, obj.reqData,httpOptions);



      }catch(err){

        // notify system api error
        this._router.navigate(['/login']);

      }



  }

  commentSave(obj:any):any{

  try{
    let  httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        "Authorization": "Bearer "+obj.token,

      })
    };

    let api_url =AppSettings.API_ENDPOINT+'comment.php';

   return this.http.post<any>(api_url, obj,httpOptions);



  }catch(err){

    this._router.navigate(['/login']);

  }

}


tracking(obj:any):any{

  try{
    let  httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        "Authorization": "Bearer "+obj.token,

      })
    };

    let api_url =AppSettings.API_ENDPOINT+'track.php';

   return this.http.post<any>(api_url, obj,httpOptions);



  }catch(err){

    this._router.navigate(['/login']);

  }

}

analytics(obj:any):any{

  try{
    let  httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        "Authorization": "Bearer "+obj.token,

      })
    };

    let api_url =AppSettings.API_ENDPOINT+'analytics.php';

   return this.http.post<any>(api_url, obj,httpOptions);



  }catch(err){

    this._router.navigate(['/login']);

  }

}


exportAsExcelFile(json: any[], excelFileName: string): void {
    
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
  this.saveAsExcelFile(excelBuffer, excelFileName);
}

saveAsExcelFile(buffer: any, fileName: string): void {
  const data: Blob = new Blob([buffer], {
    type: EXCEL_TYPE
  });
  FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
}



}
